import { css } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useState } from 'react';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import useMediaQuery from 'hooks/useMediaQuery';
import useScrollPosition from 'hooks/useScrollPosition';

import { sendEvent } from 'lib/gtag';
import { scrollToTop } from 'lib/utils';

import Z_INDEX_SCALE from 'constants/zIndexScale';

const SCROLL_POSITION_TO_SHOW_BUTTON_IN_PX = 310;
const SCROLL_POSITION_TO_SHOW_BUTTON_AFTER_LG_IN_PX = 660;

const StyledButton = styled(Button)`
  ${({ theme, isOpen }) => css`
    opacity: ${isOpen ? 1 : 0};
    visibility: ${isOpen ? 'visible' : 'hidden'};
    transition: ${theme.transitions.fast};
  `}
`;

const ScrollToTopButton = ({ gaEventCategory, mb }) => {
  const { isLg } = useMediaQuery();
  const [isOpen, setOpen] = useState(false);

  useScrollPosition(
    ({ currPos }) => {
      setOpen(
        currPos.y >=
          (isLg
            ? SCROLL_POSITION_TO_SHOW_BUTTON_AFTER_LG_IN_PX
            : SCROLL_POSITION_TO_SHOW_BUTTON_IN_PX)
      );
    },
    { deps: [isLg] }
  );

  const onClick = () => {
    if (gaEventCategory) {
      sendEvent({ action: 'go_to_top', category: gaEventCategory });
    }

    scrollToTop();
  };

  return (
    <StyledButton
      icon={<Icon name="keyboard-arrow-up" />}
      size="size2"
      type="primary"
      position="sticky"
      ml="auto"
      mb={mb}
      bottom={4}
      right={4}
      zIndex={Z_INDEX_SCALE.SIZE_2}
      isOpen={isOpen}
      onClick={onClick}
    />
  );
};

ScrollToTopButton.defaultProps = {
  gaEventCategory: null,
};

ScrollToTopButton.propTypes = {
  gaEventCategory: PropTypes.string,
};

export default ScrollToTopButton;
